<template>
  <div id="app_signup">
    <vue-element-loading :active="appLoading" :is-full-screen="true" />

    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout wrap justify-space-around>
      <v-flex xs12 md12 pa-5>
        <v-card id="app_height" outlined>
          <v-layout wrap justify-center>
            <v-flex xs12 sm12 md12>
              <Invest v-if="dataretrived" v-bind:id="id" />
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";

import Invest from "./../Invest/Invest";

export default {
  props: ["id"],
  components: {
    Invest
  },
  data() {
    return {
      winStep: 0,
      showsnackbar: false,
      timeout: 5000,
      msg: null,
      appLoading: false,
      dataretrived: false,
      projectData: [],
      ServerError: false
    };
  },
  beforeMount() {
    this.dataretrived = true;
    // this.getData();
  },
  methods: {
    winStepper(window_data) {
      this.winStep = window_data.winStep;
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/project/get",
        params: {
          id: this.id
        },
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.dataretrived = true;
          if (response.data.status === true) {
            this.projectData = response.data.data;
            // console.log("Project Data", this.projectData);
          }
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    }
  }
};
</script>
<style scoped>
#app_signup {
  background-image: url("../../assets/home_header.png");
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}
@media only screen and (min-width: 800px) {
  #app_height {
    min-height: 80vh;
  }
}
</style>